export { queryClient, useMutationFn, useQueryFn } from "./react-query";
